import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Avatar, Box, MenuItem, Select, Typography } from "@mui/material";
import { tableDummyData } from "../navbar/NavItemsData";

const headCellSx = {
  borderBottom: "1px solid #2a2a2a",
  color: "#777",
  fontSize: "12px",
  fontWeight: 700,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  backgroundColor: "#1a1a1a",
  py: 1.5,
};

const rowSx = {
  cursor: "pointer",
  transition: "0.2s",
  "& td": { borderBottom: "1px solid #1e1e1e", color: "#ccc" },
  "&:hover": { backgroundColor: "#1f1f1f", "& td": { color: "#FFC001" } },
};

const SoldItemTableHeadings = ["", "Animals", "Type", "Date", "Price"];

const filters = [
  "Last 1 day",
  "Last 7 days",
  "Last 15 days",
  "Last 1 month",
  "Last 3 months",
  "Last 6 months",
  "Last 1 year",
];

const RecentOrders = () => {
  const [filter, setFilter] = useState(filters[1]);

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "16px", overflow: "hidden" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 2.5, py: 1.5, borderBottom: "1px solid #2a2a2a" }}>
        <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>
          Recently Sold Items
        </Typography>
        <Select
          value={filter}
          size="small"
          onChange={(e) => setFilter(e.target.value)}
          sx={{
            fontSize: "12px",
            color: "#aaa",
            height: 32,
            ".MuiOutlinedInput-notchedOutline": { borderColor: "#333" },
            "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#555" },
            ".MuiSvgIcon-root": { color: "#555" },
          }}
        >
          {filters.map((f) => (
            <MenuItem key={f} value={f} sx={{ fontSize: "13px" }}>
              {f}
            </MenuItem>
          ))}
        </Select>
      </Box>
      <Box sx={{ overflowX: "auto" }}>
        <Table sx={{ borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow>
              {SoldItemTableHeadings.map((item) => (
                <TableCell key={item} align="center" sx={headCellSx}>
                  {item}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableDummyData.map((data) => (
              <TableRow key={data.animal} sx={rowSx}>
                <TableCell align="left" sx={{ width: 0, p: "8px 12px" }}>
                  <Avatar
                    alt={data.animal}
                    src={data.image}
                    sx={{ width: 40, height: 40, borderRadius: "8px" }}
                  />
                </TableCell>
                <TableCell align="center" sx={{ fontSize: "13px" }}>{data.animal}</TableCell>
                <TableCell align="center" sx={{ fontSize: "13px" }}>{data.type}</TableCell>
                <TableCell align="center" sx={{ fontSize: "13px" }}>{data.date}</TableCell>
                <TableCell align="center" sx={{ fontSize: "13px", color: "#FFC001 !important", fontWeight: 700 }}>
                  {data.price}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default RecentOrders;
